function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { withModifiers } from '../../decorators';

var MenuSubMenu = function MenuSubMenu(_ref) {
  var others = _extends({}, _ref);

  return React.createElement("ul", others);
};

MenuSubMenu.propTypes = {
  children: PropTypes.any.isRequired
};
MenuSubMenu.displayName = 'Menu.SubMenu';
export default withModifiers(MenuSubMenu);